import { AI_TIERS } from "@/constants/aiTiersCatalog";

const tier1 = AI_TIERS[0];

export const WEAPON_HOOK = {
  label: "PARTNER OPPORTUNITY",
  headline: "White-label this stack under your brand.",
  body: `100% margin spread on every client slot (${tier1.profitLabel.replace(" per client", "")}). See tiers and calculate your book below.`,
  cta: "See the weapon",
  target: "white-label-weapon",
};
